import loadable from '@loadable/component';
export const manifest = {
  SmeDeliveryManagement: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement" */
          './components/delivery-management-control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/delivery-management-control");
            }

            return eval('require.resolve')("./components/delivery-management-control");
          }

        }, {
          resolveComponent: m => m.SmeDeliveryManagement
        })
      }
    }
  },
  'SmeDeliveryManagement.ToggleModal': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.ToggleModal";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.ToggleModal" */
          './components/toggle-modal'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/toggle-modal");
            }

            return eval('require.resolve')("./components/toggle-modal");
          }

        }, {
          resolveComponent: m => m.ToggleModal
        })
      }
    }
  },
  'SmeDeliveryManagement.ShowModal': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.ShowModal";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.ShowModal" */
          './components/show-modal'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/show-modal");
            }

            return eval('require.resolve')("./components/show-modal");
          }

        }, {
          resolveComponent: m => m.ShowModal
        })
      }
    }
  },
  'SmeDeliveryManagement.MobileModal': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.MobileModal";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.MobileModal" */
          './components/mobile-modal'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/mobile-modal");
            }

            return eval('require.resolve')("./components/mobile-modal");
          }

        }, {
          resolveComponent: m => m.MobileModal
        })
      }
    }
  },
  'SmeDeliveryManagement.MobileModalHeader': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.MobileModalHeader";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.MobileModalHeader" */
          './components/mobile-modal-header'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/mobile-modal-header");
            }

            return eval('require.resolve')("./components/mobile-modal-header");
          }

        }, {
          resolveComponent: m => m.MobileModalHeader
        })
      }
    }
  },
  'SmeDeliveryManagement.ApplicationsViewer': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.ApplicationsViewerDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.ApplicationsViewerDesktop" */
          './components/applications-viewer-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/applications-viewer-desktop");
            }

            return eval('require.resolve')("./components/applications-viewer-desktop");
          }

        }, {
          resolveComponent: m => m.ApplicationsViewerDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.ApplicationsViewerMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.ApplicationsViewerMobile" */
          './components/applications-viewer-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/applications-viewer-mobile");
            }

            return eval('require.resolve')("./components/applications-viewer-mobile");
          }

        }, {
          resolveComponent: m => m.ApplicationsViewerMobile
        })
      }
    }
  },
  'SmeDeliveryManagement.Control': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.Control";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.Control" */
          './components/control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/control");
            }

            return eval('require.resolve')("./components/control");
          }

        }, {
          resolveComponent: m => m.Control
        })
      }
    }
  },
  'SmeDeliveryManagement.InitControl': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.InitControl";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.InitControl" */
          './components/init-control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/init-control");
            }

            return eval('require.resolve')("./components/init-control");
          }

        }, {
          resolveComponent: m => m.InitControl
        })
      }
    }
  },
  'SmeDeliveryManagement.Reasons': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryManagement.Reasons";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryManagement.Reasons" */
          './components/reasons'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/reasons");
            }

            return eval('require.resolve')("./components/reasons");
          }

        }, {
          resolveComponent: m => m.Reasons
        })
      }
    }
  }
};